import React from 'react';

export interface ITableElement {
  className?: string;
  [others: string]: any;
}


const formatValue = (children: any) => {
  if (children?.length > 30) {
    const firstLineText = children?.slice(0, 30);
    let secondLineText = children?.slice(30);
    if (secondLineText?.length > 30) {
      secondLineText = secondLineText?.slice(0, 30) + '...';
    }
    return <>{firstLineText} <br />{secondLineText}</>
  }
  return children
}

const TElement: React.FC<ITableElement> = ({ children, className, ...rest }) => (
  <td className={className || ''} {...rest}>
    <div className="table-content">
      {formatValue(children)}
    </div>
  </td>
);

export default TElement;
